import React, { forwardRef } from "react";
import type { ReactNode, ComponentProps } from "react";

import debounce from "lodash.debounce";
import { Button } from "native-base";
import type { GestureResponderEvent } from "react-native";

export type ButtonDebouncedRef = {
  focus: () => void;
} | null;

type ButtonProps = ComponentProps<typeof Button>;

interface Props extends ButtonProps {
  children?: ReactNode;
  debounceTime?: number;
}

const ButtonDebounced = forwardRef<ButtonDebouncedRef, Props>((props, ref) => {
  const debouncedOnPress = (event: GestureResponderEvent) => {
    props.onPress && props.onPress(event);
  };

  const onPress = debounce(debouncedOnPress, props.debounceTime ?? 500, {
    leading: true,
    trailing: false,
  });

  return (
    // @ts-expect-error native-base ref type is not properly typed
    <Button {...props} ref={ref} onPress={onPress}>
      {props.children}
    </Button>
  );
});

export default ButtonDebounced;
